(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/personalized-content/assets/javascripts/use-personalized-content-allowed.js') >= 0) return;  svs.modules.push('/components/oddset/personalized-content/assets/javascripts/use-personalized-content-allowed.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const logger = new svs.core.log.Logger('components:oddset:personalized-content-allowed:use-personalized-content-allowed');
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;

const usePersonalizedContentAllowed = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPersonalizedContentAllowed = _useState2[0],
    setIsPersonalizedContentAllowed = _useState2[1];
  useEffect(() => {
    try {
      const getRelevantContent = async () => {
        var _customizedSettingsRe;
        const customizedSettingsRes = await svs.core.jupiter.callAsync({
          method: 'GET',
          path: '/player/2/customizedsettings'
        });
        setIsPersonalizedContentAllowed(Boolean(customizedSettingsRes === null || customizedSettingsRes === void 0 || (_customizedSettingsRe = customizedSettingsRes.response) === null || _customizedSettingsRe === void 0 || (_customizedSettingsRe = _customizedSettingsRe.customizedSettings) === null || _customizedSettingsRe === void 0 || (_customizedSettingsRe = _customizedSettingsRe.properties) === null || _customizedSettingsRe === void 0 ? void 0 : _customizedSettingsRe.relevantContent));
      };
      const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
      if (isLoggedIn && !isSelfService) {
        getRelevantContent();
      }
    } catch (error) {
      logger.warn('Error fetching user preference for relevant content', error);
    }
  }, []);
  return {
    isPersonalizedContentAllowed
  };
};
setGlobal('svs.components.oddset.personalizedContent', {
  usePersonalizedContentAllowed
});

 })(window);